module.exports = __webpack_public_path__ + "media/images/mobile/logo_q-cfff76142f0a5d7efe821c436480d7ff.gif";